var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(function (a) { return _vm.isVisible(a); }),expression:"(a) => isVisible(a)"}],staticClass:"Animation",class:_vm.class_root},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }